<template>
  <div id="Login">
    <div class="login_box">
      <Title title_name="會員中心"></Title>
      <div class="login_box_content">
        <div class="social_login">
          <h3>您可以使用Facebook、Google、Line帳號登入</h3>
          <div class="social_type">
            <div v-for="(item, index) in social_type" :key="index">
              <a href="" @click.prevent="social_login(item.type)">
                <img :src="item.src" :alt="item.type + '.jpg'">
              </a>
            </div>
          </div>
        </div>
        <div class="login_info">
          <h2>登入會員</h2>
          <form>
            <div class="input_container">
              <input type="text" required="required" id="email" :class="{'error_input' : !email_check}" v-model="email" v-on:keyup.enter="submit_login" autofocus/>
              <label for="#email" :class="{'check_value' : email!=null}">帳號</label>
            </div>
            <div class="input_container">
              <input type="password" required="required" id="password" :class="{'error_input' : password == ''}" v-model="password" v-on:keyup.enter="submit_login"/>
              <label for="#password" :class="{'check_value' : password!=null}">密碼</label>
            </div>
          </form>
        </div>
        <div class="forget_box">
          <div></div>
          <div style="color: #00a0e9;">
            <router-link to="/forget_account" style="color: #00a0e9;">忘記帳號</router-link>|
            <router-link to="/forget_password" style="color: #00a0e9;">忘記密碼</router-link>
          </div>
          <div></div>
        </div>
        <MoreButton button_text="確認送出" @click.native="submit_login"  button_href="javascript:void(0);" :loading="loading"></MoreButton>
      </div>
    </div>
    <div class="member_registration">
      <h2>還不是會員?</h2>
      <p>立刻加入上聯會員取得展覽活動報名資訊</p>
      <MoreButton button_text="點此註冊" button_href="register" ></MoreButton>
    </div>
  </div>
</template>

<script>
import Title from '@/components/base/Title'
import MoreButton from '@/components/base/MoreButton'
export default {
  name: "login",
  components: {
    'MoreButton': MoreButton,
    'Title': Title,
  },
  data() {
    return {
      login_data: new FormData(),
      email: "",
      password: "",
      social_type: [
        {type: 'facebook', src: require('@/assets/social_icon/facebook_login.jpg')},
        {type: 'line', src: require('@/assets/social_icon/line_login.jpg')},
        {type: 'google', src: require('@/assets/social_icon/google_login.jpg')},
      ],
      loading: false,
      reg: null,
      email_check: false,
    };
  },
  created(){
    this.$cookies.isKey('member') ? this.$router.push('/member/ticket') : null
  },
  computed: {
    API() {
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/"
    }
  },
  watch: {
    email: function(v){
      this.reg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      this.email_check = this.reg.test(v)
      // console.log(this.email_check)
    }
  },
  methods: {
    submit_login() {
      var vm = this
      var login_api = vm.API + "api/auth/login/web"
      vm.login_data.set("email", vm.email)
      vm.login_data.set("password", vm.password)
      vm.loading = true
      
      if(vm.email_check){
        vm.axios.post(login_api, vm.login_data).then(res => {
        // console.log(res)
          if (res.data.status == 200) {
            // cookie 時效為半天
            vm.$cookies.config(60*60*12, '')
            vm.$cookies.set('member', JSON.stringify(res.data.data))
            vm.loading = false
            vm.$router.push('/member/ticket')
          } else if(res.data.status == 711){
            vm.$router.push({name: 'email_auth', params: {email: vm.email}})
          } else {
            alert("錯誤碼: " + res.data.status + " " + res.data.message)
            vm.loading = false
          }
        })
        .catch(function(error) {
          console.log(error)
          // alert(error)
        })
      } else {
        alert('email 格式有誤，請重新檢查')
        vm.loading = false
      }
    },
    social_login(type){
      // var redirect_url = location.protocol +'//'+ location.host +location.pathname+'social/link'
      // var redirect_url = location.protocol +'//'+ location.host+':8080' + location.pathname+'social/link'
      var redirect_url = process.env.NODE_ENV === "production" ? location.protocol +'//'+ location.host +location.pathname+'social/link' : location.protocol +'//'+ location.host+':8080' + location.pathname+'social/link'
      var url = 'https://sso.top-link.com.tw/social/login/'+ type +'?redirect_url=' + redirect_url
      location.href = url
    },
  }
}
</script>
<style>
#Login {
  margin: 0 auto;
  padding: 10px;
  background-color: rgb(0,0,0,0.07)
}
.login_box {
  width: 500px;
  max-width: 100%;
  margin: 15px auto 0;
  border-radius: 20px;
  border: 3px solid #37c5f3;
  overflow: hidden;
}
.login_box .title {
  text-align: center;
  background: #37c5f3;
  height: 52px;
  font-size: 2rem;
  font-weight: bold;
}
.login_box_content {
  width: 90%;
  margin: auto;
}
.social_login h3 {
  text-align: center;
  padding: 20px 0 10px 0;
  border-bottom: 2px solid #37c5f3;
}
.social_type {
  margin: 20px 0;
  display: flex;
  justify-content: space-around;
  width: 80%;
  margin: auto;
}
.social_type div {
  width: 80px;
  height: auto;
}
.login_info h2 {
  text-align: center;
  padding: 0 0 10px 0;
  margin: 10px 0;
  border-bottom: 2px solid #37c5f3;
}
.login_info form {
  display: flex;
  flex-direction: column;
  padding: 0 0 10px 0;
}
.input_container {
  position: relative;
  margin-top: 40px;
}
.input_container label {
  position: absolute;
  top: -12px;
  left: 0;
  color: #757575;
  font-size: 28px;
  font-weight: bold;
  line-height: 60px;
  transition: all 0.2s ease;
}
.input_container input {
  width: 100%;
  height: 36px;
  font-size: 19px;
  border: none;
  background: #abd8ff;
  padding-left: 5px;
}
.input_container input:focus ~ label,
.input_container input:valid ~ label,
.check_value {
  color: black;
  transform: translate(-20%, -60%) scale(0.65);
}
.error_input {
  background-color: #f88094 !important;
}
.forget_box {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}
.forget_box div:nth-child(odd) {
  width: calc((100% - 400px / 2));
  height: 2px;
  background: #37c5f3;
}
.forget_box div:nth-child(even) {
  width: 400px;
  display: flex;
  justify-content: space-between;
  margin: 0 20px;
}
.submit {
  margin: 30px 0;
}
.member_registration{
  width: 350px;
  max-width: 100%;
  margin: 0 auto 10px;
  text-align: center;
}
.member_registration h2 {
  text-align: center;
  padding: 0 0 10px 0;
  margin: 20px 0 10px;
  border-bottom: 2px solid #37c5f3;
}
.member_registration p{ font-size: 19px;}
@media (max-width: 380px) {
  .social_type{
    width: 100%;
  }
}
</style>
